import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { PROJECT_SETTINGS } from 'src/modules/common/codecs/ProjectSettings';
import { Project } from 'src/modules/common/types/Project';
import { ProjectSettings } from 'src/modules/common/types/ProjectSettings';
import { call } from 'typed-redux-saga';

export function* saveProjectSettings(
  project: Project,
  settings: ProjectSettings,
): SagaIterator<void> {
  try {
    const raw = yield* call(PROJECT_SETTINGS.encode, settings);
    yield* call(makeRestRequest, 'PUT', `/projects/${encodeURIComponent(project.id)}/settings`, raw);
  } catch (error) {
    throw new RuntimeError('Could not save project settings', { project, settings }, NativeError.wrap(error));
  }
}
